import { Link, useNavigate } from "react-router-dom";
import { Home as HomeIcon, ArrowLeft, Search, Briefcase, Phone } from "lucide-react";

export default function NotFound() {
  const navigate = useNavigate();
  return (
    <div data-testid="page-404" className="min-h-[80vh] bg-white flex items-center py-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 w-full">
        <div className="overline mb-4 text-center"><span className="red-dot" />Erreur 404</div>
        <h1 className="font-display text-[10rem] sm:text-[14rem] lg:text-[20rem] font-bold leading-[0.85] tracking-tighter text-center">
          404
        </h1>
        <div className="text-center mt-6">
          <h2 className="font-display text-2xl md:text-3xl font-bold tracking-wide uppercase">
            Page non trouvée
          </h2>
          <div className="w-16 h-0.5 bg-[#E60000] mx-auto mt-6 mb-8" />
          <p className="text-gray-600 leading-relaxed max-w-md mx-auto mb-10">
            La page que vous recherchez n&apos;existe pas ou a été déplacée. Voici quelques pistes pour retrouver votre chemin&nbsp;:
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 max-w-2xl mx-auto mb-10">
            <Link to="/realisations" data-testid="nf-link-realisations" className="group flex flex-col items-center gap-2 p-5 border border-gray-200 hover:border-[#E60000] transition-colors">
              <Search className="w-5 h-5 text-[#E60000]" strokeWidth={1.5} />
              <span className="text-xs uppercase tracking-wider font-semibold">Réalisations</span>
            </Link>
            <Link to="/metiers" data-testid="nf-link-metiers" className="group flex flex-col items-center gap-2 p-5 border border-gray-200 hover:border-[#E60000] transition-colors">
              <Briefcase className="w-5 h-5 text-[#E60000]" strokeWidth={1.5} />
              <span className="text-xs uppercase tracking-wider font-semibold">Nos métiers</span>
            </Link>
            <Link to="/contact" data-testid="nf-link-contact" className="group flex flex-col items-center gap-2 p-5 border border-gray-200 hover:border-[#E60000] transition-colors">
              <Phone className="w-5 h-5 text-[#E60000]" strokeWidth={1.5} />
              <span className="text-xs uppercase tracking-wider font-semibold">Contact</span>
            </Link>
          </div>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <button
              data-testid="back-btn-404"
              onClick={() => navigate(-1)}
              className="inline-flex items-center gap-3 border border-gray-300 hover:border-[#E60000] hover:text-[#E60000] px-8 py-4 text-sm font-semibold tracking-wide uppercase transition-colors"
            >
              <ArrowLeft className="w-4 h-4" strokeWidth={1.5} /> Page précédente
            </button>
            <Link
              to="/"
              data-testid="back-home-btn"
              className="inline-flex items-center gap-3 bg-[#E60000] hover:bg-[#B30000] text-white px-8 py-4 text-sm font-semibold tracking-wide uppercase transition-colors"
            >
              <HomeIcon className="w-4 h-4" strokeWidth={1.5} /> Retour à l&apos;accueil
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
